export const checkPreviousButton = (page) => {
  return page > 1;
};

export const checkEmptyData = (data, page, keyword) => {
  return keyword && data.length == 0 && page <= 1 && keyword.length != 0;
};

export const checkPaginationNext = (data) => {
  return data.length === 10;
};
